<template>
  <!-- 业务员审核 -->
  <div class="salesmanAudit">
    <!-- 面包屑导航 -->
    <crumbs-bar
      @refresh="handleRefresh"
      :crumbsList="['业务员管理', $route.meta.title]"
    >
    </crumbs-bar>
    <!-- 搜索框 -->
    <search-bar>
      <template>
        <!-- <el-select v-model="searchForm.Audit" style='width:100px'>
					<el-option value="0,1,2" label="全部"></el-option>
					<el-option value="1" label="已禁用"></el-option>
					<el-option value="2" label="已启用"></el-option>
				</el-select> -->
        <!-- <el-input style="width:200px;margin-right:5px" clearable placeholder="输入分组ID"
					v-model="searchForm.name"></el-input> -->
        <el-button type="primary" icon="el-icon-search" @click="getTableData"
          >搜索</el-button
        >
        <el-button type="primary" icon="el-icon-plus" @click="getAddTo"
          >添加</el-button
        >
        <el-button type="danger" @click="handleDel()">删除</el-button>
      </template>
    </search-bar>
    <!-- 数据展示 -->

    <el-table
      :data="tableData"
      stripe
      border
      height="calc(100% - 130px)"
      row-key="Id"
      @selection-change="selectionChange"
      style="width: 100%"
      :tree-props="{ children: 'Child', hasChildren: 'hasChildren' }"
    >
      <el-table-column type="selection" align="center" width="55">
      </el-table-column>
      <el-table-column
        label="序号"
        align="center"
        width="50"
        type="index"
      ></el-table-column>
      <el-table-column
        prop="Id"
        label="分组ID"
        align="center"
        show-overflow-tooltip
        min-width="180"
      ></el-table-column>
      <el-table-column
        prop="Name"
        label="分组名称"
        align="center"
        show-overflow-tooltip
        min-width="250"
      ></el-table-column>
      <el-table-column
        prop="LastModifyTime"
        label="更新时间"
        align="center"
        show-overflow-tooltip
        min-width="180"
      ></el-table-column>
      <!-- <el-table-column prop="status" label="状态" align="center" show-overflow-tooltip min-width="150"></el-table-column> -->
      <el-table-column label="操作" align="center" min-width="240">
        <template slot-scope="scope">
          <!-- <el-button type="danger" style="padding:2px 3px;" plain>禁用</el-button> -->
          <el-button
            type="primary"
            style="padding: 2px 3px"
            plain
            @click="getGrouping(scope.row)"
            v-if="scope.row.Level != '4'"
            >添加</el-button
          >
          <el-button
            type="warning"
            style="padding: 2px 3px"
            plain
            @click="getModify(scope.row)"
            >修改</el-button
          >
          <el-button
            type="danger"
            style="padding: 2px 3px"
            plain
            @click="getDelete(scope.row)"
            >删除</el-button
          >
          <el-button
            type="primary"
            style="padding: 2px 3px"
            plain
            @click="getBinding(scope.row.Code)"
            >绑定业务员</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-dialog
      title="添加分组"
      :visible.sync="PrimaryGrouping_show"
      width="45%"
      :close-on-click-modal="false"
    >
      <div>
        <el-form label-width="150px">
          <el-form-item label="分组名称" required>
            <el-input
              clearable
              placeholder="请输入分组"
              v-model="PrimaryGrouping"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div style="display: flex; justify-content: center">
        <el-button @click="PrimaryGrouping_show = false">取 消</el-button>
        <el-button type="primary" @click="getPrimaryGrouping">确定</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="修改分组"
      :visible.sync="ModifyPrimaryGrouping_show"
      width="45%"
      :close-on-click-modal="false"
    >
      <div>
        <el-form label-width="150px">
          <el-form-item label="分组名称" required>
            <el-input
              clearable
              placeholder="输入分组"
              v-model="ModifyPrimaryGrouping"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div style="display: flex; justify-content: center">
        <el-button @click="PrimaryGrouping_show = false">取 消</el-button>
        <el-button type="primary" @click="getModifyPrimaryGrouping"
          >确定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "salesmanGroup",
  data() {
    return {
      /**表格数据 */
      //序号	单位	用户名	真实姓名	手机号	创建日期	状态	操作
      tableData: [],
      selectedList: [],
      /**搜索表单 */
      searchForm: {
        name: "",
        Audit: "1",
      },
      PrimaryGrouping_show: false, //分组名称
      PrimaryGrouping: "", //分组名称
      level: "", //分组层级
      parentId: "", //父级

      ModifyPrimaryGrouping_show: false, //修改弹窗
      ModifyPrimaryGrouping: "", //修改名称
      ModifyId: "", //修改code
    };
  },
  components: {},
  created() {
    this.getTableData();
  },
  methods: {
    /**获取数据 */
    getTableData() {
      let data = {
        parentId: "",
        entId: window.localStorage.getItem("entId"),
      };
      this.$request({
        url: "/Management/SalesManAdmin/GetGroupTree",
        method: "post",
        data: data,
      })
        .then((res) => {
          if (res.success) {
            this.tableData = res.dataList;
          } else {
            //失败提示
            this.$message({
              message: res.message,
              type: "error",
            });
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    /**刷新表格数据 */
    handleRefresh() {
      this.getTableData();
    },
    //添加一级分组
    getAddTo() {
      this.PrimaryGrouping_show = true; //一级分组名称
      this.PrimaryGrouping = ""; //一级分组名称
      this.level = "1";
      this.parentId = "root";
    },
    //添加二级三级分组
    getGrouping(row) {
      if (row.Level == "1") {
        this.level = "2";
      } else if (row.Level == "2") {
        this.level = "3";
      } else {
        this.level = "4";
      }

      this.parentId = row.Code;
      this.PrimaryGrouping_show = true; //一级分组名称
      this.PrimaryGrouping = ""; //一级分组名称
    },
    //分组确定
    getPrimaryGrouping() {
      let data = {
        name: this.PrimaryGrouping,
        level: this.level,
        parentId: this.parentId,
        entId: window.localStorage.getItem("entId"),
      };
      this.$request({
        url: "GradeTree/GroupNew",
        method: "post",
        data: data,
      })
        .then((res) => {
          if (res.success) {
            this.$message({
              message: "添加成功！",
              type: "success",
            });
            this.PrimaryGrouping_show = false; //一级分组名称
            this.getTableData();
          } else {
            //失败提示
            this.$message({
              message: res.message,
              type: "error",
            });
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    //修改分组
    getModify(row) {
      this.ModifyPrimaryGrouping_show = true; //修改弹窗
      this.ModifyPrimaryGrouping = row.Name; //修改名称
      this.ModifyId = row.Id; //修改code
    },
    //修改确定
    getModifyPrimaryGrouping() {
      let data = {
        name: this.ModifyPrimaryGrouping,
        id: this.ModifyId,
        entId: window.localStorage.getItem("entId"),
      };
      this.$request({
        url: "GradeTree/GroupUpdate",
        method: "post",
        data: data,
      })
        .then((res) => {
          if (res.success) {
            this.$message({
              message: "修改成功！",
              type: "success",
            });
            this.ModifyPrimaryGrouping_show = false; //一级分组名称
            this.getTableData();
          } else {
            //失败提示
            this.$message({
              message: res.message,
              type: "error",
            });
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    /**客户 selection change触发事件 */
    selectionChange(section) {
      //存放选中的表格数据
      this.selectedList = section;
    },
    handleDel() {
      let row = {};
      if (this.selectedList.length == 1) {
        row = this.selectedList[0];
        this.getDelete(row);
      } else {
        this.$message({
          message: "只能删除一条数据",
          type: "warning",
        });
      }
    },
    //删除
    getDelete(row) {
      this.$confirm("是否删除此分组?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let data = {
            list: row.Code,
            entId: window.localStorage.getItem("entId"),
          };
          this.$request({
            url: "GradeTree/GroupDelete",
            method: "post",
            data: data,
          })
            .then((res) => {
              if (res.success) {
                this.$message({
                  message: "删除成功！",
                  type: "success",
                });
                this.getTableData();
              } else {
                //失败提示
                this.$message({
                  message: res.message,
                  type: "error",
                });
              }
            })
            .catch((err) => {
              window.console.log(err);
            });
        })
        .catch(() => {
          this.$message.info("取消删除！");
        });
    },
    //绑定业务员
    getBinding(list) {
      let prams = null;
      if (list) {
        prams = encodeURIComponent(JSON.stringify(list));
      } else {
        prams = list;
      }
      this.$router.push({
        path: "BindingSalesman",
        query: {
          prams: prams,
        },
      });
      prams = null;
    },
    /**绑定分组 */
    handleBind(row) {
      let prams = null;
      if (row) {
        prams = encodeURIComponent(JSON.stringify(row));
      } else {
        prams = row;
      }
      this.$router.push({
        path: "bindGroup",
        query: {
          row: prams,
        },
      });
      prams = null;
    },
  },
};
</script>

<style scoped>
.salesmanAudit {
  width: 100%;
  height: 100%;
}
</style>
